<div class="ict-column" [ngClass]="{ 'pb-1': isMobile }">
  <div class="bar-container" *ngIf="!isMobile">
    <div class="bar" *ngFor="let color of ict.colors" [ngStyle]="getBarClass(color, ict.colors.length)"></div>
  </div>
  <div class="flex justify-start align-start gap-[20px]">
    <rfc-icon [iconInput]="ict.icon" *ngIf="ict.icon.iconName"></rfc-icon>
    <div class="text">{{ ict.text }}</div>
  </div>
  <div class="center mt-05">
    <mat-chip-set>
      <mat-chip class="ict-chip" [ngClass]="getClassChip(ict)">{{
        ict.chip
        }}</mat-chip>
    </mat-chip-set>
  </div>
</div>